import React, { useContext, useEffect } from 'react';
import AppContext from '@context';
import When from '@components/ui/When';
import useAmplitude from '@hooks/useAmplitude';
import useLoadProposals from '@hooks/useLoadProposals';
import { clickTagsNames } from '@helpers/handleClickEvent';
import { ProposalPendingInterface } from '@interface/proposals';
import useLoadJourneys from '@hooks/useLoadJourneys';
import { JourneyListProposalsPropsInterface } from './JourneyListProposalsTypes';
import JourneyListProposalsDesktop from './Desktop';
import JourneyListProposalsMobile from './Mobile';

// @TODO: alterar nome do componente para ProposalsList
function JourneyListProposals({
  isMobile,
}: JourneyListProposalsPropsInterface) {
  const {
    state: {
      proposals: { pending: proposals },
      journeys: {
        all: { currentPage: currentPageJourney },
      },
      filters,
    },
    dispatch,
  } = useContext(AppContext);
  const { fetchProposals } = useLoadProposals();
  const { fetchJourneys } = useLoadJourneys('lazy');
  const { amplitudeEvent } = useAmplitude();
  const tagsNames = ['FUEL-BUTTON', 'BUTTON', 'FUEL-ICON', 'FUEL-BADGE'];
  const showListProposals = currentPageJourney === 1 && !filters.status.length;

  function handleFetchProposal() {
    fetchProposals({ page: 1 });
    fetchJourneys({ page: 1 });
  }

  function handleClick(proposal: ProposalPendingInterface) {
    if (proposal) {
      dispatch({
        type: 'ui_drawerProposal_set_show',
        payload: { isShow: true, proposalId: proposal.id },
      });
      dispatch({ type: 'proposal_selection_set', payload: proposal });
    }
    amplitudeEvent('proposal_list_item_clicked', {
      source: 'clicou-no-item-da-lista',
      proposal_id: proposal.id,
    });
  }

  useEffect(() => {
    if (showListProposals) {
      amplitudeEvent('journey_list_proposals_viewed');

      window.addEventListener('proposalConfirmedSuccess', handleFetchProposal);
    }

    return () => {
      window.removeEventListener(
        'proposalConfirmedSuccess',
        handleFetchProposal,
      );
    };
  }, []);

  if (
    !showListProposals ||
    proposals.error ||
    (proposals.isFetched && !proposals.data.length)
  ) {
    return null;
  }

  return (
    <>
      <When isShow={!isMobile}>
        <JourneyListProposalsDesktop
          handleClick={(event, proposal) =>
            clickTagsNames(event, tagsNames, () => handleClick(proposal))
          }
        />
      </When>
      <When isShow={isMobile}>
        <JourneyListProposalsMobile
          handleClick={(event, proposal) =>
            clickTagsNames(event, tagsNames, () => handleClick(proposal))
          }
        />
      </When>
    </>
  );
}

export default JourneyListProposals;
